var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'overlay overlay-block': _vm.isLoading }},[_vm._t("default"),(_vm.isLoading)?_c('div',{staticClass:"overlay-layer bg-dark-o-20"},[_c('div',{staticClass:"spinner spinner-primary"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }